import React, { Fragment, lazy } from "react";
import SEO from "../../components/ceo/CEO";

// Lazy loading the components
const Hero = lazy(() => import("./hero/Hero"));
const Blog = lazy(() => import("./blog/Blog"));
const Project = lazy(() => import("./project/Project"));
const Team = lazy(() => import("./team/Team"));
const Activities = lazy(() => import("./activities/Activities"));
const Donate = lazy(() => import("./donate/Donate"));
const Partner = lazy(() => import("./partner/Partner"));

const HomeIndex = () => {
  return (
    <Fragment>
      <SEO
        title="Home"
        description="Welcome to SHALL Social and Development Organization. We empower communities through sustainable solutions, education, and innovation."
        url="https://shallafg.org/"
        image="https://shallafg.org/media/images/logo.png"
      />

      <Hero />
      <Activities />
      <Donate />
      <Team />
      <Project />
      <Blog />
      <Partner />
    </Fragment>
  );
};

export default HomeIndex;
